import { computed, type ComputedRef } from 'vue'

export function contentStableComputed<T>(getter: () => T): ComputedRef<T> {
  let previousKey: string | undefined
  return computed((previous) => {
    const value = getter()
    const key = JSON.stringify(value)
    if (previous !== undefined && key === previousKey) return previous
    previousKey = key
    return value
  })
}
